export const getCSSFontSrc = (format: string, url: string): string =>
  `url('${url}') format('${format}')`;
